import TextField from "../../../components/fields/textField/TextField.vue";
import TextAreaField from "../../../components/fields/textAreaField/TextAreaField.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import { ExercicioService } from "../../../services/ExercicioService";
import { ElementoItemService } from "../../../services/ElementoItemService";
import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";

export default {
    components: {
        TextField,
        TextAreaField,
        SelectField,
        Breadcrumb,
    },
    name: "CriarElementoItem",
    props: {
        activeModal: {
            default: false,
            type: Boolean,
        }
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Elementos Itens',
                disabled: false,
                href: '/gerenciar-elementos-itens'
            },
            {
                text: 'Cadastro de Elemento Item',
                disabled: true
            }
        ],
        elemento_item: {
            exercicio: '',
            codigo_elemento_item: '',
            descricao: '',
            ativo: false
        },
        exerciciosOptions: [],
        loading: false,
    }),
    created() {
        this.listarExerciciosSelect();
    },
    watch: {
        activeModal(val) {
            if (val) {
                this.resetForm();
            }
        },
    },
    methods: {
        resetForm() {
            this.elemento_item.ativo = false;
            this.elemento_item.exercicio = '';
            this.elemento_item.codigo_elemento_item = '';
            this.elemento_item.descricao = '';
            this.elemento_item.ativo = 0;
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        },
        submitForm() {
            this.$refs.form.validate();
            if (!this.$refs.form.$invalid) {
              this.salvarElementoItem();
            }
        },
        async salvarElementoItem() {

            const isValid = this.$refs.form.validate();

            if (!isValid) {
                return false;
            }

            this.loading = true;

            const formData = new FormData();

            formData.append("exercicio", this.elemento_item.exercicio);
            formData.append("codigo_elemento_item", this.elemento_item.codigo_elemento_item);
            formData.append("descricao", this.elemento_item.descricao );
            formData.append("ativo", this.elemento_item.ativo ? 1 : 0);

            try {
                const response = await ElementoItemService.store(formData);
                
                // Verifica se a resposta ou response.data contém erros
                if (response?.errors || response?.data?.errors) {
                    const errors = response?.errors || response?.data?.errors;
                    this.$emit('save-error', errors);
                    this.loading = false;
                    return;
                }
                
                // Se não houver erros, emite o evento de sucesso e fecha
                this.$emit('elemento-item-salvo');
                this.close();
            } catch (error) {
                // Captura erros da requisição
                const errors = error.response?.data?.errors || { error: ['Erro ao salvar o elemento item'] };
                this.$emit('save-error', errors);
                this.loading = false;
            }
        },
        async close() {
            this.loading = false;
            this.resetForm();
            this.$emit("on-close");
        },
        async listarExerciciosSelect() {
            try {
                const response = await ExercicioService.select();
                if (response) {
                    this.exerciciosOptions = response.data.map((el) => {
                        return {
                            text: el.ano,
                            value: el.ano,
                        };
                    });
                    this.exerciciosOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os exercícios.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os exercícios:', error);
            }
        }
    }
};
